import {Field, Formik, FormikHelpers as FormikActions} from 'formik';
import {default as React} from 'react';
import {Button} from '~/components/Button';
import {InputType} from '~/components/Controls/Input';
import {Form, FormColumn, FormControls, FormRow, FormTitle, InputField, IntentText, SelectField} from '~/components/Form';
import {IModalComponent, IModalComponentClose} from '~/components/Modal';
import {Intent} from '~/lib/intent';
import {IUser, userRoles, UserSchema} from '~/modules/Users/models/User';

interface IUserForm {
    user?: IUser;
    onSubmit?: (values: IUser, formikActions: FormikActions<IUser>, close: IModalComponentClose) => void;
}

export const UserForm: IModalComponent<IUserForm> = (props) => <Formik initialValues={props.user}
    validationSchema={UserSchema}
    onSubmit={(user, actions) => props.onSubmit(user, actions, props.close)}
>
    {({values: user, status, isSubmitting}) => <Form>
        <FormTitle>{user.id ? 'Edit user' : 'Create user'}</FormTitle>
        {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
        <FormRow>
            <FormColumn>
                <Field name='name'
                    options={{
                        placeholder: 'User name',
                        disabled: isSubmitting
                    }}
                    label='Name'
                    component={InputField}
                />
                <Field name='email'
                    label='Email'
                    options={{
                        type: InputType.EMAIL,
                        placeholder: 'Email',
                        disabled: user.id || isSubmitting
                    }}
                    component={InputField}
                />
                <Field name='company'
                    label='Company'
                    options={{
                        placeholder: 'Company',
                        disabled: isSubmitting
                    }}
                    component={InputField}
                />
                <Field name='role'
                    label='Role'
                    options={{
                        placeholder: 'Role',
                        items: userRoles,
                        disabled: isSubmitting
                    }}
                    component={SelectField}
                />
            </FormColumn>
        </FormRow>
        <FormControls>
            <Button disabled={isSubmitting}
                onClick={props.close}
            >Cancel</Button>
            <Button type='submit'
                disabled={isSubmitting}
                intent={Intent.PRIMARY}
                rightIcon={isSubmitting && <i className='fa fa-spinner fa-spin'/>}
            >Save</Button>
        </FormControls>
    </Form>}
</Formik>;
